import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { post } from "../Services/api.service";
import { Paths } from "../Services/EndPoints";
import { IoMdCheckmark } from "react-icons/io";

// Translate icon in the same line-icon family/weight as the header cart & menu
// (Feather/Lucide, stroke-2, round caps) so all header icons look identical.
function TranslateIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-5 h-5 text-ink-900"
    >
      <path d="m5 8 6 6" />
      <path d="m4 14 6-6 2-3" />
      <path d="M2 5h12" />
      <path d="M7 2h1" />
      <path d="m22 22-5-10-5 10" />
      <path d="M14 18h6" />
    </svg>
  );
}

export const LanguageSwitcher = ({ isLoggedin = true }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleOnlyStatic = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setIsOpen(false);
    window.location.reload();
  };

  const changeLang = async (lang) => {
    post(`${Paths.change_lang}?language=${lang}`)
      .then((res) => {
        if (res?.status === "SUCCESS") {
          setIsOpen(false);
          i18n.changeLanguage(lang);
          localStorage.setItem("i18nextLng", lang);
          window.location.reload();
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        ref={triggerRef}
        className="w-[38px] h-[38px] rounded-[10px] bg-wc-gray flex justify-center items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <TranslateIcon />
      </div>

      {isOpen && (
        <div
          ref={popoverRef}
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            zIndex: 1000,
            minWidth: "170px",
            maxWidth: "90vw",
          }}
          className="bg-white rounded-2xl shadow-2xl border border-gray-300"
        >
          <div className="flex flex-col py-1">
            <span className="px-4 py-2 text-base font-normal text-black">
              {t("languageSwitcher.chooseLanguage")}
            </span>
            {[
              { name: "English", key: "en" },
              { name: "हिन्दी", key: "hi" },
            ].map((item, index) => (
              <div key={item.key}>
                <span
                  className="px-4 py-2 text-base font-light cursor-pointer transition-colors flex items-center justify-between"
                  onClick={() =>
                    isLoggedin
                      ? changeLang(item.key)
                      : handleOnlyStatic(item.key)
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <span>{item.name}</span>
                  {((["en", "en-US"].includes(
                    localStorage.getItem("i18nextLng"),
                  ) &&
                    item.key === "en") ||
                    localStorage.getItem("i18nextLng") === item.key) && (
                    <IoMdCheckmark className="text-green ml-2" />
                  )}
                </span>
                {index === 0 && <hr className="border-gray-300 mx-3" />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
